<p
    *ngIf="isExpired()"
    style="color: red;"
>
    <strong>
        Your credential(s) will be listed as expired. Are you sure you want to continue?
    </strong>
</p>
<form
    [formGroup]="thirdPartyForm"
    (ngSubmit)="onSubmit(thirdPartyForm.value)"
>
    <fieldset>
        <legend>Send To Third Party</legend>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="name"
                    class="label"
                >
                    Name of Institution
                </label>
                <input
                    class="input input--large"
                    id="name"
                    name="name"
                    [class.input--invalid]="formErrors.name"
                    uppercase
                    formControlName="name"
                    maxlength="35"
                >
                <div
                    *ngIf="formErrors.name"
                    class="error-message field__error-message"
                >
                    {{ formErrors.name }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="country"
                        class="label"
                    >
                        Country
                    </label>
                    <select
                        class="input input--select-menu input--large"
                        [class.input--invalid]="formErrors.countryId"
                        id="country"
                        formControlName="countryId"
                        required
                    >
                        <option value>Select One</option>
                        <option
                            *ngFor="let c of countries"
                            [value]="c.id"
                        >
                            {{c.description}}
                        </option>
                    </select>
                    <div
                        *ngIf="formErrors.countryId"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.countryId }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="address1"
                        class="label"
                    >
                        Address Line 1
                    </label>
                    <input
                        class="input"
                        id="address1"
                        name="address1"
                        [class.input--invalid]="formErrors.address1"
                        uppercase
                        formControlName="address1"
                        maxlength="35"
                    >
                    <div
                        *ngIf="formErrors.address1"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.address1 }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="address2"
                        class="label"
                    >
                        Address Line 2
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        id="address2"
                        name="address2"
                        [class.input--invalid]="formErrors.address2"
                        uppercase
                        formControlName="address2"
                    >
                    <div
                        *ngIf="formErrors.address2"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.address2 }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="address3"
                        class="label"
                    >
                        Address Line 3
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        id="address3"
                        name="address3"
                        [class.input--invalid]="formErrors.address3"
                        uppercase
                        formControlName="address3"
                    >
                    <div
                        *ngIf="formErrors.address3"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.address3 }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="zipCode"
                        class="label"
                    >
                        Zip&#x2F;Postal Code
                    </label>
                    <!-- <input
  *ngIf="!isUSZip()"
  class="input"
  id="zipCode"
  name="zipCode"
  [mask]="'SSSSSSSSSS'"
  [dropSpecialCharacters]="true"
  uppercase
  maxlength="10"
  (blur)="zip = $event.target.value"
  [class.input--invalid]="formErrors.zip"
  formControlName="zip"
/> -->
                    <input
                        class="input"
                        id="zipCode"
                        name="zipCode"
                        maxlength="10"
                        (blur)="performZipCodeLookup()"
                        uppercase
                        [class.input--invalid]="formErrors.zip"
                        formControlName="zip"
                    >
                    <div
                        *ngIf="formErrors.zip"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.zip }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="city"
                        class="label"
                    >
                        City
                    </label>
                    <input
                        class="input"
                        id="city"
                        name="city"
                        [class.input--invalid]="formErrors.city"
                        uppercase
                        formControlName="city"
                    >
                    <div
                        *ngIf="formErrors.city"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.city }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="state"
                        class="label"
                    >
                        State&#x2F;Province
                    </label>
                    <input
                        class="input"
                        id="state"
                        name="state"
                        [class.input--invalid]="formErrors.state"
                        uppercase
                        formControlName="state"
                        maxlength="50"
                    >
                    <div
                        *ngIf="formErrors.state"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.state }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-actions form-actions--multi-step">
            <input
                ng-disabled="!isValidZip()"
                class="button form-actions__item form-actions__item--continue"
                type="submit"
                value="Continue"
            >
            <button
                (click)="onBack($event)"
                class="button button--secondary form-actions__item form-actions__item--back"
            >
                Back
            </button>
        </div>
    </fieldset>
</form>
